import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="text-xs font-semibold font-['Inter'] px-2 py-0.5 rounded-[4px]" [class]="badgeClasses" >
      <ng-content></ng-content>
    </span>
  `,
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {
  @Input() variant: BadgeVariant = BadgeVariant.neutral;

  get badgeClasses(): string {
    switch(this.variant) {
      case BadgeVariant.success:
        return 'bg-[#7ECA5B] text-white';
      case BadgeVariant.warning:
        return 'bg-[#FCE072] text-[#535353]';
      case BadgeVariant.error:
        return 'bg-[#FC7372] text-white';
      case BadgeVariant.neutral:
      default:
        return 'bg-[#BEBEBE] text-white';
    }
  }
}

export enum BadgeVariant {
  success = 'success',
  neutral = 'neutral',
  warning = 'warning',
  error = 'error'
};